import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private currentTheme: string | null = null;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setTheme(themeName: string) {
    if (this.currentTheme) {
      this.renderer.removeClass(document.body, this.currentTheme);
    }
    this.renderer.addClass(document.body, themeName);
    this.currentTheme = themeName;

    // opcional: guardar en localStorage
    localStorage.setItem('user-theme', themeName);
  }

  loadSavedTheme() {
    const savedTheme = localStorage.getItem('user-theme');
    if (savedTheme) {
      this.setTheme(savedTheme);
    }
  }

  getCurrentTheme(): string | null {
    return this.currentTheme;
  }
}
